/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Eraser from './eraser-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Eraser {...validProps} />;
}

SvgComponent.iconName = 'eraser';

export const EraserIcon = svgIconWrapper(SvgComponent);
